// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7aad7561","977":"fad38823"}[chunkId] + ".chunk.js";
};